import * as yup from 'yup';

export const requestAccessSchema = yup.object().shape({
  first_name: yup.string().required('Имя обязательно'),
  last_name: yup.string().required('Фамилия обязательна'),
  patronymic: yup.string().required('Отчество обязательно'),
  company_name: yup.string().required('Название компании обязательно'),
  phonemy: yup
    .string()
    .required('Пожалуйста, введите номер телефона')
    .matches(
      /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/,
      'Пожалуйста, введите корректный номер телефона'
    ),
  email: yup.string().email('Некорректный email').required('Email обязателен'),
});
